import CheckboxGroupInput from 'shared/components/molecules/CheckboxGroupInput/CheckboxGroupInput';
export * from 'shared/components/molecules/CheckboxGroupInput/validation';

export default CheckboxGroupInput;
